/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetEquipmentBrowserConfigRequest = {
  agentId: string;
};

/** @internal */
export type GetEquipmentBrowserConfigRequest$Outbound = {
  agent_id: string;
};

/** @internal */
export const GetEquipmentBrowserConfigRequest$outboundSchema: z.ZodType<
  GetEquipmentBrowserConfigRequest$Outbound,
  z.ZodTypeDef,
  GetEquipmentBrowserConfigRequest
> = z.object({
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function getEquipmentBrowserConfigRequestToJSON(
  getEquipmentBrowserConfigRequest: GetEquipmentBrowserConfigRequest,
): string {
  return JSON.stringify(
    GetEquipmentBrowserConfigRequest$outboundSchema.parse(
      getEquipmentBrowserConfigRequest,
    ),
  );
}
